export default __webpack_public_path__ + "static/media/Heartgirth Girdle.8f08cadb.jpg";